import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { anatomyConstants } from "../../../constants/anatomyConstants";

const Tabs = ({ activeTab, onTabClick, setIsSidebarOpen }) => {
  const [isModelTooltipVisible, setModelTooltipVisible] = useState(false);
  const [isAnnotationTooltipVisible, setAnnotationTooltipVisible] =
    useState(false);
  const [isMeasurementTooltipVisible, setMeasurementTooltipVisible] =
    useState(false);
  const [isCloseTooltipVisible, setCloseTooltipVisible] = useState(false);

  return (
    <div
      className="absolute right-0 top-0 h-12 shadow-sm border-b border-[var(--main-color-bold)] w-80 transition-all duration-300 ease-in-out bg-gradient-to-r from-[var(--main-color)] to-[var(--main-color-bold)] z-30"
      style={{
        "--main-color": anatomyConstants.mainColor,
        "--main-color-bold": anatomyConstants.mainColorBold,
      }}
    >
      <div className="flex flex-row h-full">
        <div className="relative flex-1 flex">
          <button
            onClick={() => onTabClick("models")}
            onMouseEnter={() => setModelTooltipVisible(true)}
            onMouseLeave={() => setModelTooltipVisible(false)}
            className={`flex-1 flex items-center justify-center transition-all duration-300 ${
              activeTab === "models"
                ? "bg-white/20 text-white shadow-inner border-b-2 border-white"
                : "bg-transparent hover:bg-white/10 text-white/70 hover:text-white"
            }`}
          >
            <img
              src="/structures.png"
              alt="Segmented Structures"
              className="w-8 h-8"
              draggable={false}
              
            />
          </button>
          {isModelTooltipVisible && (
            <div className="absolute top-full mt-1 left-1/2 -translate-x-1/2 bg-slate-800/90 backdrop-blur-sm text-white font-medium text-xs rounded px-2 py-1 transition-opacity duration-200 z-50 pointer-events-none whitespace-nowrap shadow-md">
              Segmented Structures
            </div>
          )}
        </div>

        <div className="relative flex-1 flex">
          <button
            onClick={() => onTabClick("annotations")}
            onMouseEnter={() => setAnnotationTooltipVisible(true)}
            onMouseLeave={() => setAnnotationTooltipVisible(false)}
            className={`flex-1 flex items-center justify-center transition-all duration-300 ${
              activeTab === "annotations"
                ? "bg-white/20 text-white shadow-inner border-b-2 border-white"
                : "bg-transparent hover:bg-white/10 text-white/70 hover:text-white"
            }`}
          >
            <img
              src="/annotate_white.png"
              alt="Annotations"
              className="w-6 h-6"
              draggable={false}
            />
          </button>
          {isAnnotationTooltipVisible && (
            <div className="absolute top-full mt-1 left-1/2 -translate-x-1/2 bg-slate-800/90 backdrop-blur-sm text-white font-medium text-xs rounded px-2 py-1 transition-opacity duration-200 z-50 pointer-events-none whitespace-nowrap shadow-md">
              Annotations
            </div>
          )}
        </div>

        <div className="relative flex-1 flex">
          <button
            onClick={() => onTabClick("measurements")}
            onMouseEnter={() => setMeasurementTooltipVisible(true)}
            onMouseLeave={() => setMeasurementTooltipVisible(false)}
            className={`flex-1 flex items-center justify-center transition-all duration-300 ${
              activeTab === "measurements"
                ? "bg-white/20 text-white shadow-inner border-b-2 border-white"
                : "bg-transparent hover:bg-white/10 text-white/70 hover:text-white"
            }`}
          >
            <img
              src="/measure_white.png"
              alt="Measurements"
              className="w-6 h-6"
              draggable={false}
            />
          </button>
          {isMeasurementTooltipVisible && (
            <div className="absolute top-full mt-1 left-1/2 -translate-x-1/2 bg-slate-800/90 backdrop-blur-sm text-white font-medium text-xs rounded px-2 py-1 transition-opacity duration-200 z-50 pointer-events-none whitespace-nowrap shadow-md">
              Measurements
            </div>
          )}
        </div>

        <div className="relative flex items-center justify-center border-l border-white/20">
          <button
            onClick={() => setIsSidebarOpen(false)}
            onMouseEnter={() => setCloseTooltipVisible(true)}
            onMouseLeave={() => setCloseTooltipVisible(false)}
            className="flex items-center justify-center h-full w-12 transition-colors duration-300 bg-transparent text-white hover:bg-red-500/80"
          >
            <CloseIcon />
          </button>
          {isCloseTooltipVisible && (
            <div className="absolute top-full mt-1 right-0 bg-slate-800/90 backdrop-blur-sm text-white font-medium text-xs rounded px-2 py-1 transition-opacity duration-200 z-50 pointer-events-none whitespace-nowrap shadow-md">
              Close
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
